<template>
  <div class="container fluid">
    <div class="row justify-content-center">
      <div class="how-to-earn-points-container col-8 col-md-6" v-on:click="toggleShowHowToEarnPointsModal()">
        <span class="how-to-earn-points-text">HOW DO I EARN POINTS?
          <BIconChevronDown class="chev-down-white"/>
        </span>
      </div>
    </div>
    <HowToEarnPointsModal v-if="showHowToEarnPointsModal"></HowToEarnPointsModal>
    <div v-if="!this.isHistoricalPredictionsPage" class="text-box">
      <p class="description-text">Your prediction has been submitted!</p>
    </div>
    <div v-if="this.isHistoricalPredictionsPage" class="text-box">
      <p class="row justify-content-center description-text">Below are the predictions made and points earned by
        {{selectedPlayerUsername}}
      </p>
    </div>
    <hr class="line-break">
    <div v-for="(fixture, index) in this.currentPredictions" :key="index" class="match-box">
      <hr v-if="index > 0" class="line-break">
      <div class="date-time col-11">
        <p class="date-text">{{ formatDate(fixture.StartDate) }}</p>
      </div>
      <div class="team-icons-box col-8 col-md-6">
        <img v-if="getTeamLogo(fixture.Team1Name)" :src="getTeamLogo(fixture.Team1Name)" alt="" class="team-logo">
        <div v-if="!getTeamLogo(fixture.Team1Name)" class="generic-logo-team-box">
          <img class="generic-logo" :src="getGenericLogo()" alt="">
          <p class="generic-team-text"> {{fixture.Team1Name}}</p>
        </div>
        <p class="vs-text">VS</p>
        <img v-if="getTeamLogo(fixture.Team2Name)" :src="getTeamLogo(fixture.Team2Name)" alt="" class="team-logo">
        <div v-if="!getTeamLogo(fixture.Team2Name)" class="generic-logo-team-box">
          <img class="generic-logo" :src="getGenericLogo()" alt="">
          <p class="generic-team-text"> {{fixture.Team2Name}}</p>
        </div>
      </div>
      <div class="scores-box col-11">
        <div class="team-score-red-box col-4 team-score-red-box-left"><p class="score-number">{{ fixture.Team1Score }}</p></div>
        <div class="white-center-box col-4"><p class="white-box-text">{{
            hasGameStarted(fixture.StartDate) ? 'FT'
                : '-'
          }}</p></div>
        <div class="team-score-red-box col-4 team-score-red-box-right"><p class="score-number">{{ fixture.Team2Score }}</p></div>
      </div>
      <div v-if="isHistoricalPredictionsPage" class="how-to-earn-points-container col-8 col-md-6">
        <span class="how-to-earn-points-text">Points Earned: {{fixture.Points}}
        </span>
      </div>
    </div>
    <div v-if="isHistoricalPredictionsPage" class="edit-predictions-button-box col-12">
      <button class="edit-button"><p class="button-text">Total points Earned: {{getTotalPoints()}}</p></button>
    </div>
    <div v-if="isHistoricalPredictionsPage" class="home-button-box col-12">
      <button v-on:click="onBackClicked()" class="back-button"><p class="button-text">Back</p></button>
    </div>
    <div class="home-button-box col-12">
      <button v-bind:class="isHistoricalPredictionsPage ? 'mb-3' : ''" v-on:click="onHomeClicked()" class="home-button"><p class="button-text">Home</p></button>
    </div>
    <div v-if="!isHistoricalPredictionsPage" class="edit-predictions-button-box col-12">
      <button v-on:click="onEditPredictionsClicked()" class="edit-button"><p class="button-text">Edit
        Predictions</p></button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ScorePredictorService from "../../services/scorePredictorService";
import {sports} from "../../config/sports";
import {mapMutations, mapState} from "vuex";
import {BIconChevronDown} from 'bootstrap-vue';
import HowToEarnPointsModal from "@/components/HowToEarnPointsModal";
import Leaderboard from "../Leaderboard";

export default {
  name: "ViewSoccerPredictions",
  components: {BIconChevronDown, HowToEarnPointsModal},
  data() {
    return {
      currentPredictions: [],
      isHistoricalPredictionsPage: false,
      selectedPlayerUsername: undefined,
    }
  },
  computed: mapState(['userData', 'selectedSport', 'selectedLeague', 'selectedRound', 'showHowToEarnPointsModal', 'leaderBoardSportSelected', 'leaderboardSelectedUser']),
  methods: {
    ...mapMutations(['setRoundPredictions', 'clearRoundPredictions', 'setPointsScoringBreakdown', 'toggleShowHowToEarnPointsModal', 'setLeaderBoardSportSelected', 'setLeaderboardSelectedUser']),

    getTotalPoints() {
      let totalPonts = 0;

      this.currentPredictions.forEach((fixture) => {
        totalPonts = totalPonts + fixture.Points;
      });
      return totalPonts
    },
    onBackClicked() {
      this.$router.push({path: '/leaderboard'})
    },
    getGenericLogo() {
      return require(`../../assets/teams/Champions-League-Teams/generic-logo.png`)
    },
    getTeamLogo(teamName) {
      const teamConfig = sports.get(this.selectedSport).get(this.selectedLeague).get(teamName);
      if (!teamConfig) return undefined;
      if (teamConfig.logo === 'teams/Champions-League-Teams/NEEDS-ASSET.png') return undefined;
      if (teamConfig.logo === 'teams/EPL-Teams/NEEDS-ASSET.png') return undefined;
      if (teamConfig.logo === 'teams/Bundasliga-teams/NEEDS-ASSET.png') return undefined;
      if (teamConfig.logo === 'teams/French-ligue-1/NEEDS-ASSET.png') return undefined;
      if (teamConfig.logo === 'teams/Italian-serie-A/NEEDS-ASSET.png') return undefined;
      if (teamConfig.logo === 'teams/Spanish-LaLiga/NEEDS-ASSET.png') return undefined;
      else return require(`../../assets/${teamConfig.logo}`)
    },
    formatDate(date) {
      return moment(date).format('LLLL');
    },
    hasGameStarted(startDate) {
      if (startDate > Date.now()) return;
      return;
    },
    onHomeClicked() {
      this.$router.push('/sports');
    },
    onEditPredictionsClicked() {
      this.$router.push('make-predictions');
    },
    addRoundPredictions(fixtures) {
      fixtures.forEach((fixture) => {
        this.selectedPlayerUsername = fixture.Username;
        this.currentPredictions.push(fixture);
        this.setRoundPredictions(fixture);
      });
    },
    async getRoundPredictions() {
      if (this.leaderboardSelectedUser) {
        const response = await ScorePredictorService.getPlayerRoundPredictions(this.leaderboardSelectedUser.MSISDN, this.selectedRound);
        this.addRoundPredictions(response.roundPredictions);
        this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
        this.isHistoricalPredictionsPage = true;
        this.setLeaderBoardSportSelected(undefined);
        this.setLeaderboardSelectedUser(undefined);
      } else {
        const response = await ScorePredictorService.getRoundPredictions(this.userData.msisdn, this.selectedRound.RoundID);
        this.addRoundPredictions(response.roundPredictions);
        this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
      }

    },
    clearState() {
      this.currentPredictions = [];
      this.clearRoundPredictions();
    }
  },
  mounted() {
    this.clearState();
    this.getRoundPredictions(this.selectedLeague);
  },
}
</script>

<style scoped lang="scss">
.how-to-earn-points-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $icon-container-background-color;
  padding: 0.5rem 0;
  border-radius: 0 0 3px 3px;
  box-shadow: 4px 4px 4px black;
  margin-bottom: 0.5rem;
  z-index: 0;
}

.how-to-earn-points-text {
  color: $heading-text-color;
}

.team-icons-box {
  display: flex;
  justify-content: center;
  align-content: center;
  z-index: 0;
  padding: 1.2rem 0.5rem;
  margin-bottom: 1vh;
  border-radius: 5px;
}

.team-icons-box img {
  height: 100px;
}

.scores-box {
  display: flex;
  width: 100%;
  height: 8vh;
  z-index: 0;
}

.white-center-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: $current-prediction-score-white-cntre;
}

.team-score-red-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: $current-predictions-teamscore-background;
}

.team-score-red-box-right {
  border-radius: 0 5px 5px 0;
}

.team-score-red-box-left {
  border-radius: 5px 0 0 5px;
}

.home-button-box {
  display: flex;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
  margin-top: 2vh;
}

.edit-predictions-button-box {
  display: flex;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
  margin-top: 2vh;
}

.home-button {
   display: flex;
   justify-content: center;
   align-items: center;
   height: 8vh;
   width: 100%;
   background-color: $current-predictions-home-button;
   border-radius: 5px;
   border: none !important;
   z-index: 0;
 }

.back-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8vh;
  width: 100%;
  background-color: $current-predictions-home-button;
  border-radius: 5px;
  border: none !important;
  z-index: 0;
  margin-bottom: 1vh;
}

.edit-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8vh;
  width: 100%;
  border: solid $transperent-button-border-color 3px;
  border-radius: 5px;
  background-color: Transparent;
  z-index: 0;
  margin-bottom: 2vh;
}

.text-box {
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 1vw;
  padding: 1vw;
}

.match-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  margin-bottom: 2vh;
}


.description-text {
  z-index: 0;
  font-size: large;
  margin: 0;
}

.date-text {
  font-size: large;
  margin: 0;
}

.team-logo {
  height: auto;
  max-height: 90%;
}

.vs-text {
  display: flex;
  align-items: center;
  font-size: large;
  color: $versus-text-color;
  margin: 2vw;
}

.score-number {
  color: white;
  font-size: 6vh;
  margin: 0;
}

.white-box-text {
  color: $current-predictions-centre-match-box-text-color;
  font-size: 4vh;
  margin: 0;
}

.button-text {
  color: $button-text-color;
  font-size: large;
  padding: 0;
  margin: 0;
}

.line-break {
  color: $line-break-color;
  width: 100%;
}
</style>
